export default __webpack_public_path__ + "static/media/brown_pawn.afc5fe3d.png";